import { Injectable } from '@angular/core';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { FactoryhelperService } from '../../../shared/services/factoryHelper.service';
import { Observable, map } from 'rxjs';
import { CreateOnlinePaymentRequestModel, CreateOnlinePaymentResponseModel } from 'src/app/shared/models/Contract';
import { LogReqModel } from 'src/app/shared/models/log';
@Injectable({
  providedIn: 'root'
})
export class OnlinePaymentService {
  apiUrl: string;
  constructor(
    private readonly agTranslateService: AgTranslateService,
    private readonly factoryhelperService: FactoryhelperService,
  ) { 
    this.apiUrl = AgAppConfigService.get<string>('applicativeApiUrl');
  }

  CreateOnlinePayment(reqData: CreateOnlinePaymentRequestModel): Observable<{Result:CreateOnlinePaymentResponseModel, Errors: string | string[]}> {
    const culture = this.agTranslateService.currentLang;
    const url = `${this.apiUrl}/${culture}/onlinepayment/CreateOnlinePayment`;
    return this.factoryhelperService.post(url, reqData);
  }

  generateLog(logReqModel : LogReqModel): Observable<boolean>{
    const url = `${this.apiUrl}/online-payment-events`;
    return this.factoryhelperService.post(url, logReqModel).pipe(map((x:{Result: boolean})=>x.Result));
  }
}
